<template>
    <div>
        <pagamento :pagamento="pagamento">
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </pagamento>
        <despesas-pagamento
            :despesas="despesasDisponiveis"
            :incluirSelecao="true"
            titulo="Despesas Disponíveis"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="despesasDisponiveisSelecionadas.length === 0"
                        ><i class="fa fa-plus"></i> Associar
                        selecionadas</b-button
                    >
                </b-button-group>
                <btn-filtrar-despesas
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @despesasFiltradas="alterarDespesasDisponiveis($event)"
                ></btn-filtrar-despesas>
            </template>
            <template slot="despesaAcoes" slot-scope="data">
                <btn-to-despesa
                    :despesaId="data.despesaId"
                    :rotaDespesa="rotaDespesa"
                    :temAcessoDetalharDespesa="temAcessoDetalharDespesa"
                ></btn-to-despesa>
            </template>
            <template slot="despesaSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.despesaId"
                    v-model="despesasDisponiveisSelecionadas"
                ></b-form-checkbox>
            </template>
        </despesas-pagamento>
    </div>
</template>

<script>
import Pagamento from './PagamentoDetalhar'
import DespesasPagamento from './../despesas/DespesasPagamento'
import BtnToDespesa from './BtnToDespesa.vue'
import BtnFiltrarDespesas from './BtnFiltrarDespesas.vue'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            despesasDisponiveisSelecionadas: [],
            despesasDisponiveis: []
        }
    },

    methods: {
        obterDespesasDisponiveis() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterDespesasDisponiveis(this.$route.params.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.despesasDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        alterarDespesasDisponiveis(despesas) {
            this.despesasDisponiveisSelecionadas = [],
            this.despesasDisponiveis = despesas 
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Despesas',
                html: `Confirma a associação das despesas selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associar()
                }
            })
        },

        associar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .associarDespesas({
                    pagamentoId: this.$route.params.pagamentoId,
                    despesasId: this.despesasDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.despesasDisponiveisSelecionadas = []
                            this.obterDespesasDisponiveis()
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterDespesasDisponiveis()
    },

    components: {
        DespesasPagamento,
        Pagamento,
        BtnToDespesa,
        BtnFiltrarDespesas
    },

    computed: {
        temAcessoDetalharDespesa() {
            switch (this.$route.name) {
                case "DespesasGerais_Requisitantes_Pagamentos_AssociarDespesas":
                    return this.$temAcessoView("DESP-GERAIS-REQ-00")
                case "DespesasGerais_Fornecedores_Pagamentos_AssociarDespesas":
                    return this.$temAcessoView("DESP-GERAIS-FORN-00")
                default:
                    return null
            }
        },

        rotaDespesa() {
            switch (this.$route.name) {
                case "DespesasGerais_Requisitantes_Pagamentos_AssociarDespesas":
                    return "DespesasGerais_Requisitantes_Despesas_Detalhar"
                case "DespesasGerais_Fornecedores_Pagamentos_AssociarDespesas":
                    return "DespesasGerais_Fornecedores_Despesas_Detalhar"
                default:
                    return null
            }
        }
    }
}
</script>
